export default __webpack_public_path__ + "static/media/lead.57ac37f0.svg";